export function generateHasShipDates(shipDates) {
    return (
        shipDates[0]?.value !== 0 ||
        shipDates[1]?.value !== 0 ||
        shipDates[2]?.value !== 0
    );
}
